module.exports = __webpack_public_path__ + "static/DPT_1_Primary_logo_on_transparent_512-f4c3ed96c1eded77fc6ce55d781adf1c.png";